webpackJsonp([4],{

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SlantedPanel = exports.SectionPanel = exports.SectionImage = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(138);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Section = _react2.default.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      theme = _ref.theme;
  return _react2.default.createElement(
    "section",
    { ref: ref, className: "section " + className + " " + (theme ? "section--" + theme : "") },
    children
  );
});

var SectionImage = exports.SectionImage = function SectionImage(_ref2) {
  var src = _ref2.src;
  return _react2.default.createElement("div", {
    className: "section__image",
    style: { backgroundImage: "url(" + src + ")" }
  });
};

var SectionPanel = exports.SectionPanel = function SectionPanel(_ref3) {
  var children = _ref3.children,
      right = _ref3.right,
      _ref3$slanted = _ref3.slanted,
      slanted = _ref3$slanted === undefined ? false : _ref3$slanted,
      width = _ref3.width;

  var classNames = "section__panel";

  if (right) classNames += " section__panel--right";
  if (slanted) classNames += " section__panel--slanted";

  return _react2.default.createElement(
    "div",
    { className: "section__content", style: { width: width || null } },
    _react2.default.createElement(
      "div",
      { className: classNames },
      children
    )
  );
};

var SlantedPanel = exports.SlantedPanel = function SlantedPanel(_ref4) {
  var _ref4$className = _ref4.className,
      className = _ref4$className === undefined ? "" : _ref4$className,
      _ref4$direction = _ref4.direction,
      direction = _ref4$direction === undefined ? "left" : _ref4$direction,
      children = _ref4.children;
  return _react2.default.createElement(
    "div",
    { className: "slanted-panel slanted-panel--" + direction + " " + className },
    _react2.default.createElement(
      "div",
      { className: "section__content" },
      children
    )
  );
};

exports.default = Section;

/***/ }),

/***/ 138:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hero = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(140);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hero = exports.Hero = function Hero(_ref) {
  var heading = _ref.heading,
      subheading = _ref.subheading,
      _ref$image = _ref.image,
      image = _ref$image === undefined ? "" : _ref$image,
      large = _ref.large;
  return _react2.default.createElement(
    "div",
    { className: "hero " + (large ? "hero--large" : "") },
    _react2.default.createElement(
      "div",
      { className: "hero-image-wrapper" },
      _react2.default.createElement("div", {
        className: "hero-image",
        style: { backgroundImage: "url(" + image + ")" }
      })
    ),
    _react2.default.createElement(
      "div",
      { className: "hero-text" },
      heading && _react2.default.createElement(
        "h1",
        { className: "hero__heading" },
        heading
      ),
      subheading && _react2.default.createElement(
        "p",
        { className: "hero__sub-heading" },
        subheading
      )
    )
  );
};

exports.default = Hero;

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(11);

__webpack_require__(142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(_ref) {
  var children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? "primary" : _ref$type,
      position = _ref.position,
      style = _ref.style,
      to = _ref.to,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === undefined ? false : _ref$isDisabled,
      _ref$isSubmit = _ref.isSubmit,
      isSubmit = _ref$isSubmit === undefined ? false : _ref$isSubmit;

  var component = void 0;
  var buttonProps = {
    className: "button",
    style: style
  };

  if (type) buttonProps.className += " button--" + type;
  if (position) buttonProps.className += " button--" + position;
  if (isDisabled) buttonProps.className += " button--disabled";

  if (to) {
    buttonProps.to = to;
    component = _react2.default.createElement(
      _reactStatic.Link,
      buttonProps,
      children
    );
  } else {
    component = _react2.default.createElement(
      "button",
      _extends({
        type: isSubmit ? "submit" : "button",
        disabled: isDisabled
      }, buttonProps),
      children
    );
  }

  return component;
};

exports.default = Button;

/***/ }),

/***/ 142:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 159:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 48:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__(22);

var _reactStatic = __webpack_require__(11);

var _Section = __webpack_require__(137);

var _Section2 = _interopRequireDefault(_Section);

var _Button = __webpack_require__(141);

var _Button2 = _interopRequireDefault(_Button);

var _Hero = __webpack_require__(139);

var _Hero2 = _interopRequireDefault(_Hero);

__webpack_require__(159);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TakeAction = function TakeAction(_ref) {
  var _ref$pageData = _ref.pageData,
      heading = _ref$pageData.heading,
      heroImageLg = _ref$pageData.heroImageLg;

  return _react2.default.createElement(
    "div",
    { className: "take-action" },
    _react2.default.createElement(
      _reactHelmet.Helmet,
      null,
      _react2.default.createElement(
        "title",
        null,
        "Amour En Action | Take Action"
      )
    ),
    _react2.default.createElement(_Hero2.default, { heading: heading, image: heroImageLg }),
    _react2.default.createElement(
      _Section2.default,
      { theme: "light-grain" },
      _react2.default.createElement(
        _Section.SectionPanel,
        { padded: true },
        _react2.default.createElement(
          "h2",
          null,
          "Love Is Also A Verb"
        ),
        _react2.default.createElement(
          "p",
          null,
          "\"Little children, let us not love in word or talk but in deed and in truth.\" - 1 John 3:18"
        )
      )
    ),
    _react2.default.createElement(
      _Section2.default,
      { theme: "white" },
      _react2.default.createElement(
        _Section.SectionPanel,
        { padded: true, width: "100%" },
        _react2.default.createElement(
          "p",
          null,
          "Please consider taking action by praying for us or by financial contributions. All contributions are tax-deductible. If you prefer not to use PayPal, please send donations to the following address:",
          " ",
          _react2.default.createElement(
            "em",
            null,
            "22 Elsinore Dr, Hainesport, NJ 08036"
          )
        ),
        _react2.default.createElement(
          "form",
          {
            className: "donate-form",
            action: "https://www.paypal.com/donate",
            method: "post",
            target: "_top"
          },
          _react2.default.createElement("input", {
            type: "hidden",
            name: "hosted_button_id",
            value: "FHAKBHL4FZDA6"
          }),
          _react2.default.createElement(
            _Button2.default,
            { isSubmit: true },
            "Donate"
          ),
          _react2.default.createElement("img", {
            src: "https://www.paypalobjects.com/webstatic/en_US/i/buttons/cc-badges-ppmcvdam.png",
            alt: "Buy now with PayPal"
          }),
          _react2.default.createElement("img", {
            alt: "",
            border: "0",
            src: "https://www.paypal.com/en_US/i/scr/pixel.gif",
            width: "1",
            height: "1"
          })
        )
      )
    )
  );
};

exports.default = function () {
  return _react2.default.createElement(_reactStatic.RouteData, { component: TakeAction });
};

/***/ })

});


// WEBPACK FOOTER //
// templates/src/pages/TakeAction/TakeAction.2c0c0901.js